import { useState } from 'react'
import { useTranslations } from 'next-intl'
import NextLink from 'next/link'
import {
  Box,
  IconButton,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react'
import { CloseIcon } from '@chakra-ui/icons'
import { CALENDLY_LINK } from '@/constants'
import { PhoneCallIcon } from '@/components/icons/PhoneCallIcon'

export const FloatingCallCTA = () => {
  const t = useTranslations()
  const [isOpen, setIsOpen] = useState(true)

  return (
    <Box
      position="fixed"
      right={{ base: 4, md: 6 }}
      bottom={{ base: 4, md: 6 }}
      zIndex="popover"
    >
      <Popover
        placement="top"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        closeOnBlur={false}
        closeOnEsc={false}
        gutter={5}
        autoFocus={false}
        returnFocusOnClose={false}
      >
        <PopoverTrigger>
          <Box display="inline-block" position="relative" zIndex="popover">
            <NextLink href={CALENDLY_LINK} passHref>
              <IconButton
                as="a"
                w={{ base: '52px', md: '80px' }}
                h={{ base: '52px', md: '80px' }}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Book a call"
                icon={<PhoneCallIcon boxSize={{ base: '22px', md: '31px' }} />}
                bg="brand.600"
                color="white"
                _hover={{ bg: 'blue.500' }}
                borderRadius="6px"
                boxShadow="0 25px 50px -12px rgba(0, 0, 0, 0.25)"
              />
            </NextLink>
          </Box>
        </PopoverTrigger>
        <PopoverContent
          border="none"
          boxShadow="md"
          bg="white"
          mr={{ base: 4, md: 6 }}
          borderRadius="6px"
          w={{ base: '170px', md: '250px' }}
        >
          <IconButton
            aria-label="Close"
            icon={<CloseIcon boxSize="7px" />}
            size="xs"
            position="absolute"
            top="-30px"
            right="0px"
            color="gray.930"
            borderRadius="18px"
            bg="white"
            onClick={() => setIsOpen(false)}
            _hover={{
              bg: 'white',
            }}
          />
          <PopoverBody
            px={{ base: '12px', md: '20px' }}
            py={{ base: '8px', md: '12px' }}
            borderRadius="9px"
            color="gray.950"
          >
            <Text fontWeight="500" fontSize={{ base: '14px', md: '20px' }}>
              {t('contact-sales.want-to-talk-sooner')}
            </Text>
            <Text fontSize={{ base: '12px', md: '16px' }}>
              {t('contact-sales.book-call-now')}
            </Text>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  )
}
